var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_152563",
    "data-name": "Group 152563",
    transform: "translate(-422 -309)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9685",
    "data-name": "Ellipse 9685",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(422 309)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mongolia-tughrik-currency-symbol-svgrepo-com",
    transform: "translate(430.606 316.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103357",
    "data-name": "Path 103357",
    d: "M16.707.239A1.268,1.268,0,0,0,15.848,0H7.265a1.268,1.268,0,0,0-.838.235.758.758,0,0,0-.256.613.768.768,0,0,0,.247.6,1.251,1.251,0,0,0,.846.234h3.216V5.328L7.605,7.014A.57.57,0,1,0,8.182,8l2.3-1.349v1.8L7.605,10.136a.57.57,0,1,0,.576.983l2.3-1.348v1.87a1.527,1.527,0,0,0,.306,1.053,1,1,0,0,0,.778.322.983.983,0,0,0,.765-.318,1.54,1.54,0,0,0,.3-1.057V8.51l2.895-1.7a.57.57,0,1,0-.576-.983L12.631,7.189v-1.8l2.895-1.7a.57.57,0,1,0-.576-.983L12.631,4.067V1.686h3.216a1.284,1.284,0,0,0,.858-.237.755.755,0,0,0,.254-.6A.775.775,0,0,0,16.707.239Z",
    transform: "translate(-6.172)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnt);
export default __webpack_public_path__ + "static/media/MNT.8231ccfbec2b4f6d53e05a013592324f.svg";
export { ForwardRef as ReactComponent };